import { useState, useEffect, useCallback } from 'react';

export const useIsMobile = (borderWidth = null) => {
    const [width, setWidth] = useState(window.innerWidth);

    const handleResize = useCallback(() => {
        setWidth(window.innerWidth);
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    return borderWidth
        ? width <= borderWidth
        : width <= 600;
}